// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3dAbY","title":"ClientReferral_title__2kW3A","itemText":"ClientReferral_itemText__37pXy"};